import React from 'react';
import Modal from 'components/common/Modal';
import ModalAddNewFeed from 'components/community/components/popup/ModalAddNewFeed';
import { useSelector } from 'store';
import { default_profile } from 'constants/image';
import styled from 'styled-components';

const ViewNewFeed: React.FC = () => {
  const { openModal, closeModal, ModalPortal } = Modal();
  const user = useSelector(state => state.accounts.user);

  const profile_image =
    user.profile.profile_picture !== null
      ? user.profile.profile_picture
      : default_profile;

  return (
    <>
      <div className="hgroup">
        <span
          className="profile-img"
          style={{ backgroundImage: `url(${profile_image})` }}
        />
        <InputWrapper>
          <a onClick={openModal} style={{ cursor: 'pointer', color: '#777' }}>
            멤버들에게 당신의 이야기를 들려주세요 :)
          </a>
        </InputWrapper>
      </div>
      <ModalPortal>
        <ModalAddNewFeed closeModal={closeModal} />
      </ModalPortal>
    </>
  );
};

const InputWrapper = styled.p`
  border: 2px solid lightgray !important;
  padding: 16px 8px !important;
  border-radius: 8px;
  font-size: 16px !important;

  @media screen and (max-width: 786px) {
    font-size: 14px !important;
  }
`;

export default ViewNewFeed;
